
<nova-grid #grid [isLoading]="isLoading$ | async" [pagingToken]="data$ | async" [args]="fetchArgs$ | async"
    [defaultFetchArgs]="defaultFetchArgs" (dataNeeded)="load($event)" [reorderable]="true" [resizable]="true"
    [filterable]="true" [toolbarTemplate]="toolbarTemplate" [showClearFilterButton]="false"
    (rowSelected)="rowSelected($event)"
    [pageable]="{ buttonCount: 10, info: true, type: 'numeric', pageSizes: [10, 25, 100, 500], previousNext: true }"
    [selectable]="{enabled: true, mode: 'multiple', checkboxOnly: true}" [autoFitColumns]="false">

    <ng-template #toolbarTemplate>
        <grid-assigned-to-id-filter class="my-facilities-filter" title="My Facilities" field="showAMFacilitiesOnly"
            [assignToValue]="showAMFacilitiesOnly" [filter]="grid.filter" [filterService]="grid.filterService">
        </grid-assigned-to-id-filter>
        <div class="w-100 text-right">
            <button data-qa-id="perm_post_offer_can_export" mat-flat-button color="cancel" (click)="export()"
                class="app-common app-grid-header-right-button">
                EXPORT
            </button>
        </div>
    </ng-template>

    <ng-container *ngIf="gridMode === PermCandidatesGridMode.PreStart">
        <nova-grid-column title="Alerts" field="isStartDateTodayOrPast" [template]="alertsTemplate" [sortable]="true"
            [filterCellTemplate]="alertsFilterTemplate" width="60">
            <ng-template #alertsTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                <div *ngIf="dataItem.isStartDateTodayOrPast"
                    [attr.data-qa-id]="'am_permanent_candidates_grid_alerts_start_date_today_or_past_'+ rowIndex">
                    <em class="material-icons alert grid-alert grid-alert-icon"
                        title="Candidate Past Start Date">today</em>
                </div>
            </ng-template>
            <ng-template let-filter="filter" #alertsFilterTemplate>
                <grid-filter-layout>
                    <ng-template #popupFilter>
                        <grid-option-list-filter-popup field="alertsFilter" [filterService]="grid.filterService"
                            [options]="alertsFilterOptions" [filter]="grid.filter"
                            data-qa-id="am_permanent_candidates_grid_alerts_filter" [width]="300">
                        </grid-option-list-filter-popup>
                    </ng-template>
                </grid-filter-layout>
            </ng-template>
        </nova-grid-column>
    </ng-container>

    <ng-container *ngIf="gridMode === PermCandidatesGridMode.PreStart">
        <nova-grid-column title="Actions" field="permanentJobOfferId" [template]="actionsTemplate"
                            class="grid-actions-column"
                            width="250">
            <ng-template #actionsTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                    <div class="flex-row flex-1 justify-start items-center gap-10">
                        <button color="primary" mat-flat-button title="Confirm Start"
                        [attr.data-qa-id]="'am_permanent_candidates_grid_confirm_start_button_'+ rowIndex"
                        (click)="confirmStartForRow(dataItem)">
                        CONFIRM START
                    </button>
                    <button color="primary" mat-icon-button title="Edit" class="cell-pointer"
                            [attr.data-qa-id]="'am_permanent_candidates_grid_edit_marker_'+ rowIndex"
                            (click)="handleEdit(dataItem)">
                        <em class="material-icons">edit</em>
                    </button>
                    <button color="primary" mat-icon-button title="Remove" class="cell-pointer"
                            [attr.data-qa-id]="'am_permanent_candidates_grid_remove_marker_'+ rowIndex"
                            (click)="handleRemove(dataItem)">
                        <em class="material-icons">delete</em>
                    </button>
                </div>
            </ng-template>
        </nova-grid-column>
    </ng-container>

    <nova-grid-column title="Start Date" field="startDate" [template]="startDateTemplate" [sortable]="true"
        [filterCellTemplate]="startDateFilterCellTemplate" width="120">
        <ng-template #startDateFilterCellTemplate let-filter="filter" let-filterService="filterService">
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-date-range-filter-popup field="startDate" [filter]="filter" [filterService]="filterService"
                        data-qa-id="am_permanent_candidates_grid_start_date_filter">
                    </grid-date-range-filter-popup>
                </ng-template>
            </grid-filter-layout>
        </ng-template>

        <ng-template #startDateTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_grid_start_date_'+ rowIndex"
                [ngClass]="dataItem.startDateTodayOrPastWarningClass">{{ dataItem.startDate | date
                : 'MM/dd/yy' }}</span>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Applicant Name" field="candidateFullName" [template]="candidateNameTemplate" width="140"
        [sortable]="true" [filterCellTemplate]="candidateNameFilterCellTemplate">
        <ng-template #candidateNameTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <a class="nova__link" target="_blank"
                href="{{dataItem.aboutLink}}"
                [attr.data-qa-id]="'am_permanent_candidates_grid_applicant_name_'+ rowIndex">
                {{ dataItem.candidateFirstName | firstNameLastName:dataItem.candidateLastName }}
            </a>
        </ng-template>
        <ng-template #candidateNameFilterCellTemplate let-filter="filter">
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-clear-filter-popup [filterService]="grid.filterService" field="candidateFullName"
                        [filter]="filter"></grid-clear-filter-popup>
                </ng-template>
                <ng-template #quickFilter>
                    <grid-text-filter [filterService]="grid.filterService" class="app-nova-grid-text-filter"
                        data-qa-id="am_permanent_candidates_grid_applicant_name_filter"
                        #candidateNameFilter field="candidateFullName"  [filter]="filter"></grid-text-filter>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Job ID" field="jobId" [template]="jobIdTemplate" width="100" [sortable]="true"
        [filterCellTemplate]="jobIdFilterCellTemplate" [filterTemplate]="emptyFilterTemplate">
        <ng-template let-filterService="filterService" #jobIdFilterCellTemplate let-filter="filter">
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-clear-filter-popup [filterService]="grid.filterService" field="jobId" [filter]="filter">
                    </grid-clear-filter-popup>
                </ng-template>
                <ng-template #quickFilter>
                    <grid-number-filter [filterService]="filterService" field="jobId" type="number" [filter]="filter"
                        [allowNegative]="false" data-qa-id="am_permanent_candidates_grid_job_id_filter">
                    </grid-number-filter>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
        <ng-template #jobIdTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <a class="nova__link" target="_blank" [routerLink]="['/accountmanagers/jobs/', dataItem.jobId]"
                [attr.data-qa-id]="'am_permanent_candidates_grid_job_id_'+ rowIndex">
                {{ dataItem.jobId }}
            </a>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Recruiter" field="recruiterFullName" [template]="recruiterFullNameTemplate" width="140"
            [sortable]="true" [filterCellTemplate]="recruiterFilterCellTemplate" [filterTemplate]="emptyFilterTemplate">
        <ng-template #recruiterFullNameTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_grid_recruiter_name_'+ rowIndex">
                {{ dataItem.recruiterFirstName | firstNameLastName:dataItem.recruiterLastName}}
            </span>
        </ng-template>
        <ng-template let-filter="filter" #recruiterFilterCellTemplate>
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-clear-filter-popup [filterService]="grid.filterService" field="recruiterFullName"
                        [filter]="filter"></grid-clear-filter-popup>
                </ng-template>
                <ng-template #quickFilter>
                    <grid-text-filter [filterService]="grid.filterService" [filter]="filter" #recruiterFilter
                        field="recruiterFullName" class="app-nova-grid-text-filter"
                        data-qa-id="am_permanent_candidates_grid_recruiter_name_filter"></grid-text-filter>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Account Manager" field="accountManagerFullName" [template]="accountManagerFullNameTemplate"
        width="140" [sortable]="true" [filterCellTemplate]="accountManagerFilterCellTemplate"
        [filterTemplate]="emptyFilterTemplate">
        <ng-template #accountManagerFullNameTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_grid_am_name_'+ rowIndex">
                {{ dataItem.accountManagerFirstName | firstNameLastName:dataItem.accountManagerLastName }}
            </span>
        </ng-template>
        <ng-template let-filter="filter" #accountManagerFilterCellTemplate>
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-clear-filter-popup [filterService]="grid.filterService" field="accountManagerFullName"
                        [filter]="filter"></grid-clear-filter-popup>
                </ng-template>
                <ng-template #quickFilter>
                    <grid-text-filter [filterService]="grid.filterService" [filter]="filter" #accountManagerFilter
                        field="accountManagerFullName" class="app-nova-grid-text-filter"
                        data-qa-id="am_permanent_candidates_grid_am_name_filter"></grid-text-filter>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="System" field="systemName" [template]="systemNameTemplate" width="140" [sortable]="true"
        [filterCellTemplate]="systemFilterCellTemplate"
        [filterTemplate]="emptyFilterTemplate">
        <ng-template #systemNameTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_grid_hospital_system_name_'+ rowIndex">
                {{ dataItem.systemName }}
            </span>
        </ng-template>
        <ng-template let-filter="filter" #systemFilterCellTemplate>
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-clear-filter-popup [filterService]="grid.filterService" field="systemName"
                        [filter]="filter"></grid-clear-filter-popup>
                </ng-template>
                <ng-template #quickFilter>
                    <grid-text-filter [filterService]="grid.filterService" [filter]="filter" #systemFilter field="systemName"
                        class="app-nova-grid-text-filter"
                        data-qa-id="am_permanent_candidates_grid_hospital_system_name_filter"></grid-text-filter>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Recruiter Bonus" field="recruiterBonus" [template]="recruiterBonusTemplate" width="120"
        [sortable]="true" [filterTemplate]="emptyFilterTemplate" [filterCellTemplate]="recruiterBonusFilterCellTemplate">
        <ng-template #recruiterBonusFilterCellTemplate let-filter="filter" let-filterService="filterService">
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-number-range-filter-popup field="recruiterBonus" [filter]="filter" [filterService]="filterService"
                        minTitle="Min Recruiter Bonus:" maxTitle="Max Recruiter Bonus:" [min]="0" [max]="15000" format="c" data-qa-id="am_permanent_candidates_grid_recruiter_bonus_filter">
                    </grid-number-range-filter-popup>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
        <ng-template #recruiterBonusTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_recruiter_bonus_'+ rowIndex">{{ dataItem.recruiterBonus
                | currency:'$':'symbol':'1.2-2' }}</span>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Offer Date" field="offerDate" [template]="offerDateTemplate" width="120" [sortable]="true"
        [filterTemplate]="emptyFilterTemplate" [filterCellTemplate]="offerDateFilterCellTemplate">
        <ng-template #offerDateFilterCellTemplate let-filter="filter" let-filterService="filterService">
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-date-range-filter-popup field="offerDate" [filter]="filter" [filterService]="filterService"
                        data-qa-id="am_permanent_candidates_grid_offer_date_filter">
                    </grid-date-range-filter-popup>
                </ng-template>
            </grid-filter-layout>
        </ng-template>

        <ng-template #offerDateTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_grid_offer_date_'+ rowIndex">{{ dataItem.offerDate | date
                : 'MM/dd/yy' }}</span>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column
        [title]="changeFacilityColumnName() ? 'Facility Profile' : 'Facility'"
        field="facilityName" [template]="facilityNameTemplate" width="140" [sortable]="true"
        [filterCellTemplate]="facilityFilterCellTemplate" [filterTemplate]="emptyFilterTemplate">
        <ng-template #facilityNameTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <a class="nova__link" target="_blank"
                routerLink="/accountmanagers/facilities/{{ dataItem.facilityId }}/facility-profile" rel="noopener"
                [attr.data-qa-id]="'am_permanent_candidates_grid_facility_'+ rowIndex">
                {{ dataItem.facilityName }}
            </a>
        </ng-template>
        <ng-template let-filter="filter" #facilityFilterCellTemplate>
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-clear-filter-popup [filterService]="grid.filterService" field="facilityName"
                        [filter]="filter"></grid-clear-filter-popup>
                </ng-template>
                <ng-template #quickFilter>
                    <grid-text-filter [filterService]="grid.filterService" [filter]="filter" #facilityFilter
                        field="facilityName" class="app-nova-grid-text-filter" data-qa-id="am_permanent_candidates_grid_facility_filter"></grid-text-filter>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Billing Amount" field="billingAmount" [template]="billingAmountTemplate" width="120"
        [sortable]="true" [filterTemplate]="emptyFilterTemplate" [filterCellTemplate]="billingAmountFilterCellTemplate">
        <ng-template #billingAmountFilterCellTemplate let-filter="filter" let-filterService="filterService">
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-number-range-filter-popup field="billingAmount" [filter]="filter" [filterService]="filterService"
                        minTitle="Min Billing Amount:" maxTitle="Max Billing Amount:" [min]="0" [max]="15000" format="c" data-qa-id="am_permanent_candidates_grid_billing_amount_filter">
                    </grid-number-range-filter-popup>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
        <ng-template #billingAmountTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_grid_billing_amount_'+ rowIndex">{{ dataItem.billingAmount
                | currency:'$':'symbol':'1.2-2' }}</span>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Submitted Date" field="submittedDate" [template]="submittedDateTemplate" width="120"
        [sortable]="true" [filterTemplate]="emptyFilterTemplate" [filterCellTemplate]="submittedDateFilterCellTemplate">
        <ng-template #submittedDateFilterCellTemplate let-filter="filter" let-filterService="filterService">
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-date-range-filter-popup field="submittedDate" [filter]="filter" [filterService]="filterService"
                        data-qa-id="am_permanent_candidates_grid_submitted_date_filter">
                    </grid-date-range-filter-popup>
                </ng-template>
            </grid-filter-layout>
        </ng-template>

        <ng-template #submittedDateTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_grid_submitted_date_'+ rowIndex">{{ dataItem.submittedDate
                | date : 'MM/dd/yy' }}</span>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Days to Offer" field="daysToOffer" filterType="numberrange"
        [template]="daysToOfferTemplate" [filterTemplate]="emptyFilterTemplate" [sortable]="true"
        [filterCellTemplate]="daysToOfferFilterTemplate" width="120">
        <ng-template let-filterService="filterService" #daysToOfferFilterTemplate let-filter="filter"
            data-qa-id="am_permanent_candidates_grid_days_to_offer_template">
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-number-range-filter-popup #daysToOfferFilter field="daysToOffer" [filter]="filter"
                        data-qa-id="am_permanent_candidates_grid_days_to_offer_filter" [filterService]="filterService"
                        minTitle="Min Days:" maxTitle="Max Days:" [min]="0" [max]="200" format="n">
                    </grid-number-range-filter-popup>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
        <ng-template #daysToOfferTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_grid_days_to_offer_'+ rowIndex">{{
                dataItem.daysToOffer
                }}</span>
        </ng-template>
    </nova-grid-column>

    <nova-grid-column title="Final Billing Amt." field="discountedBillingAmount"
        [template]="discountedBillingAmountTemplate" width="120" [sortable]="true" [filterTemplate]="emptyFilterTemplate" [filterCellTemplate]="discountedBillingAmountFilterCellTemplate">
        <ng-template #discountedBillingAmountFilterCellTemplate let-filter="filter" let-filterService="filterService">
            <grid-filter-layout>
                <ng-template #popupFilter>
                    <grid-number-range-filter-popup field="discountedBillingAmount" [filter]="filter" [filterService]="filterService"
                                                    minTitle="Min Final Billing Amount:"
                                                    maxTitle="Max Final Billing Amount:" [min]="0" [max]="15000"
                                                    format="c"
                                                    data-qa-id="am_permanent_candidates_grid_discounted_billing_amount_filter">
                    </grid-number-range-filter-popup>
                </ng-template>
            </grid-filter-layout>
        </ng-template>
        <ng-template #discountedBillingAmountTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
            <span [attr.data-qa-id]="'am_permanent_candidates_grid_discounted_billing_amount_'+ rowIndex">{{
                dataItem.discountedBillingAmount | currency:'$':'symbol':'1.2-2' }}</span>
        </ng-template>
    </nova-grid-column>

</nova-grid>

<ng-template #emptyFilterTemplate> </ng-template>
